import { Component, Input, OnInit } from '@angular/core';
import { TonnageRatingDataResponse } from '../../../model/tonnage/tonnage-rating-response.model';
import { TonnageRating } from '../../../model/tonnage/tonnage-rating.model';

@Component({
  selector: 'lms-lms-tonnage-lmps-table',
  templateUrl: './lms-tonnage-lmps-table.component.html',
  styleUrls: ['./lms-tonnage-lmps-table.component.scss']
})
export class LmsTonnageLmpsTableComponent implements OnInit {
  @Input() lmpsTonnageRatings: TonnageRating[] = [];
  @Input() lmpsHeadings: [];

  constructor() { }

  ngOnInit(): void {
  }

}
